import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataTask4100To4199Service {

  constructor() { }
}
